import './styles/common/App.css';
import { AppRouter } from './routing/AppRouter';

function App() {
  return (
    <div className="App">
      <AppRouter/>
    </div>
  );
}

export default App;
